import React from "react";

function Experience({ experience }) {
	return (
		<li className='mb-20 ml-6'>
			<span className='flex absolute -left-5 justify-center items-center w-10 h-10 bg-yellow-100 rounded-full'>
				<svg
					aria-hidden='true'
					className='w-5 h-5 text-yellow-500'
					fill='currentColor'
					viewBox='0 0 20 20'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path
						fill-rule='evenodd'
						d='M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
					></path>
				</svg>
			</span>
			<div className='pl-5'>
				<h1 className='flex items-center mb-1 text-xl font-bold text-gray-200'>
					{experience.companyName}
				</h1>
				<h3 className='flex items-center mb-1 text-md font-semibold text-gray-300'>
					{experience.role}
				</h3>
				<time className='block mt-2 mb-2 text-sm font-normal leading-none text-gray-500'>
					{experience.duration}
				</time>
				{!experience.multipleProjects && (
					<div className='mt-5'>
						{experience.points &&
							experience.points.map((point, index) => {
								return (
									<p key={index} className='mb-2 text-base font-normal'>
										<span className='text-gray-100'>{"-"}</span> {point}
									</p>
								);
							})}
					</div>
				)}
				{experience.multipleProjects && (
					<div className='mt-5'>
						{experience.points &&
							experience.points.map((point, index) => {
								return (
									<div key={index} className='mb-8'>
										<span className='text-gray-300 font-normal text-base block mb-3'>
											{"🔖 "} {point.project}
										</span>
										{point &&
											point.points.map((p, index) => {
												return (
													<p
														key={index}
														className='text-base font-normal block mb-2'
													>
														<span className='text-gray-100'>{"- "}</span> {p}
													</p>
												);
											})}
									</div>
								);
							})}
					</div>
				)}
				{experience.document && experience.document !== "" && (
					<a
						target='__blank'
						href={experience.document}
						className='mt-5 inline-flex items-center py-2 px-4 text-sm font-medium rounded-lg text-gray-400 bg-gray-800 border-0 focus:outline-none hover:bg-gray-700 hover:text-white'
					>
						<svg
							className='mr-2 w-4 h-4'
							fill='currentColor'
							viewBox='0 0 20 20'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								fill-rule='evenodd'
								d='M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z'
								clip-rule='evenodd'
							></path>
						</svg>
						View Certificate
					</a>
				)}
			</div>
		</li>
	);
}

export default Experience;
